import { useQuery } from '@apollo/client'
import { useCallback } from 'react'
import { GetCommentRepliesDocument } from '~/__generated__/graphql'
import { Configs } from '../configs'

export const useRepliesQuery = (videoId: string, commentId: string) => {
  const query = useQuery(GetCommentRepliesDocument, {
    variables: { id: commentId, first: Configs.replies.limit },
  })

  const edges = query.data?.commentReplies.edges
  const pageInfo = query.data?.commentReplies.pageInfo
  const loadMore = useCallback(() => {
    if (!!edges && pageInfo?.hasNextPage == true) {
      query.fetchMore({
        variables: {
          after: edges[edges.length - 1].cursor ?? pageInfo?.endCursor,
        },
      })
    }
  }, [edges, pageInfo?.endCursor, pageInfo?.hasNextPage, query])

  return {
    query,
    loadMore,
  }
}
